export default __webpack_public_path__ + "assets/bcbe17184b13c88bb69d98a0dde4b1c1.png";